<template>
    <div id="contactContainer">
        <!-- 第一屏 -->
        <Screen1></Screen1>
        <!-- 第二屏 -->
        <Screen2></Screen2>
        <!-- 第三屏 -->
        <Screen3></Screen3>
        <!-- 第四屏 -->
        <Screen4></Screen4>
        <!-- 第五屏 -->
        <Screen5></Screen5>
    </div>
</template>

<script>
import Screen1 from '@/components/contact/Screen1.vue'
import Screen2 from '@/components/contact/Screen2.vue'
import Screen3 from '@/components/contact/Screen3.vue'
import Screen4 from '@/components/contact/Screen4.vue'
import Screen5 from '@/components/contact/Screen5.vue'

export default {
    name: 'Contact',
    components: {
        Screen1,
        Screen2,
        Screen3,
        Screen4,
        Screen5,
    },
    mounted(){
        this.$store.state.activeIndex = "/contact"
    }
}
</script>

<style>
    .contNavTitle{
        width: 1100px;
        padding: 0 10px;
        line-height: 43px;
        overflow: hidden;
        margin: 0 auto;
    }
    .contNavTitle>div{
        float: left;
        border-bottom: 2px solid #1971d2;
        font-size: 16px;
    }
</style>